// Shared formatting helpers for Langfuse tool observations. Both add-in hosts
// capture truncated previews of tool I/O so traces stay readable without
// shipping unbounded payloads: the PowerPoint agent primitives
// (`powerpoint/services/ai/agentEditTools.ts`) and tool dispatcher
// (`powerpoint/services/ai/tools.ts`), and the Excel agent loops
// (`excel/executorNativeReactRunner.ts`, `excel/excelAIService.ts`). Keeping one
// implementation here prevents the copies from drifting (e.g. different
// truncation caps or shapes).

export const TOOL_OBSERVATION_PREVIEW_MAX_CHARS = 500;

export function truncateToolObservationPreview(
  value: string,
  maxChars = TOOL_OBSERVATION_PREVIEW_MAX_CHARS
): string {
  if (value.length <= maxChars) return value;
  return `${value.slice(0, maxChars)}... (truncated, len=${value.length})`;
}

export function summarizeForToolObservation(value: unknown): unknown {
  if (value == null || typeof value === "number" || typeof value === "boolean") return value;
  if (typeof value === "string") return truncateToolObservationPreview(value);
  try {
    const serialized = JSON.stringify(value);
    if (serialized.length <= TOOL_OBSERVATION_PREVIEW_MAX_CHARS) return value;
    return {
      preview: truncateToolObservationPreview(serialized),
      type: Array.isArray(value) ? "array" : "object",
    };
  } catch {
    return {
      type: typeof value,
      preview: truncateToolObservationPreview(String(value)),
    };
  }
}
